<template>
    <div :class="`ivu-minible-menu-${theme}`">
        <slot name="logo"></slot>  
        <component :is="shrink ? 'SiderMini' : 'SiderBar'" @on-select="handleSelect"></component>
    </div>
</template>
<script>

import SiderBar from './sider-bar.vue'
import SiderMini from './sider-bar-mini.vue'
import {mapActions} from 'vuex'
import {mixins} from './sider'
export default {
    mixins:[mixins],
    methods: {
        ...mapActions('app/',['open']),
        async handleSelect (name) {
            this.open(name);
        },
    },
    components:{SiderBar,SiderMini},
}
</script>
